<template>
  <div>
    <div class="page-header-C flx flx-wrap">
      <h2>Sınav Yorumları</h2>
    </div>

    <r-data-list
      :headdata="headdata"
      :listdata="listArray"
      :opt="opts"
      v-if="loaded"
      :searchfilter="searchfilter"
      v-model:qu="q"
    >
      <template v-slot:titleextrabuttons>
        <r-select
          v-model="selectedYearMonth"
          label="Dönem (Yıl / Ay)"
          :data="yearMonthOptions"
          txt="txt"
          val="val"
          width="24%"
          @change="onYearMonthChange"
        />
        <r-select
          v-model="selectedBranchId"
          label="Branş (Opsiyonel)"
          :data="branchOptions"
          txt="title"
          val="id"
          width="24%"
          class="r-ml-8"
        />
        <r-btn
          bgcolor="#1e88e5"
          class="r-ml-8"
          @click="reloadList"
          :disabled="isLoading || !selectedYearMonth"
        >
          Listele
        </r-btn>
        <r-btn
          bgcolor="#15880d"
          class="r-ml-8"
          @click="openNewModal"
          :disabled="isLoading || !selectedYearMonth"
        >
          Yeni Yorum
        </r-btn>
        <r-btn
          bgcolor="#6a1b9a"
          class="r-ml-8"
          @click="createKapakPdf"
          :disabled="!canExportKapak || isExporting"
        >
          Kapak PDF
        </r-btn>
      </template>
      <template v-slot:col2="{ datarow }">
        {{ getTeacherName(datarow.teacherId) }}
      </template>
      <template v-slot:col3="{ datarow }">
        {{ getBranchName(datarow.branchId) }}
      </template>
      <template v-slot:col4="{ datarow }">
        <div v-html="shortComment(datarow.commentHtml)"></div>
      </template>
      <template v-slot:rowextrabtn="{ datarow }">
        <r-btn
          bgcolor="#1e88e5"
          size="small"
          class="r-mr-8"
          @click="openEditModal(datarow)"
        >
          Düzenle
        </r-btn>
        <r-btn bgcolor="#9c0000" size="small" @click="deleteComment(datarow)">
          Sil
        </r-btn>
      </template>
    </r-data-list>

    <r-modal
      :title="modalTitle"
      v-if="modalVisible"
      v-model:isactive="modalVisible"
      width="70%"
      class="exam-comment-modal"
      :closeout="false"
    >
      <div class="r-mb-16">
        <strong>Dönem:</strong>
        <span class="r-ml-8">{{ periodLabel }}</span>
      </div>

      <r-flex class="r-mb-16">
        <r-select
          v-model="formData.teacherId"
          label="Eğitmen"
          :data="teacherOptions"
          txt="name"
          val="id"
          width="48%"
          :disabled="isTeacherUser"
        />
        <r-select
          v-model="formData.branchId"
          label="Branş"
          :data="modalBranchOptions"
          txt="title"
          val="id"
          width="48%"
          class="r-ml-8"
          :disabled="isTeacherUser"
        />
      </r-flex>

      <div class="tag-summary-box r-mb-16" v-if="formData.branchId">
        <h4>
          Seçilen branş için dinamik etiket özeti
          <span class="tag-summary-period">({{ periodLabel }})</span>
        </h4>
        <div v-if="tagSummaryLoading" class="tag-summary-loading">
          Etiket istatistikleri yükleniyor...
        </div>
        <div v-else-if="!tagSummary.length" class="tag-summary-empty">
          Bu sınav döneminde bu branş için etiketli soru bulunamadı.
        </div>
        <div v-else class="tag-summary-table-wrapper">
          <table class="tag-summary-table">
            <thead>
              <tr>
                <th>Soru Numarası</th>
                <th>Bölümü</th>
                <th>Zorluk Seviyesi</th>
                <th v-for="label in tagMatrixColumns" :key="'th-' + label">
                  {{ label }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in tagMatrixRows" :key="'row-' + row.id">
                <td>{{ row.number }}</td>
                <td>{{ row.branch }}</td>
                <td>{{ row.difficulty }}</td>
                <td
                  v-for="label in tagMatrixColumns"
                  :key="'cell-' + row.id + '-' + label"
                  class="tag-cell-check"
                >
                  {{ row.tags[label] ? "✓" : "" }}
                </td>
              </tr>
            </tbody>
          </table>
          <div class="tag-summary-footer">
            Toplam soru: <strong>{{ tagSummaryTotal }}</strong>
          </div>
        </div>
      </div>

      <div class="hint-box r-mb-16">
        <h4>İpuçları / Nelerden Bahsedebilirsiniz?</h4>
        <ul>
          <li>Eğitmenlerin sınav için temennileri</li>
          <li>Branş olarak sınavın zorluk düzeyi</li>
          <li>Sınava çalışanların başarma / yapma olasılığı</li>
          <li>Soru dağılımının homojenliği</li>
          <li>Zor, orta, kolay soru sayıları ve oranlarının değerlendirmesi</li>
          <li>Daha önceki TUS sorularıyla benzerlik / tekrar durumu</li>
          <li>Kurum kitaplarımızdan / materyallerden referanslar</li>
          <li>Atipik / sürpriz soruların değerlendirmesi</li>
          <li>Zaman yönetimi ve sınav süresinin yeterliliği</li>
          <li>Gelecek sınavlara hazırlananlara kısa öneriler</li>
        </ul>
      </div>

      <div class="r-mb-16">
        <vue-editor
          v-model="formData.commentHtml"
          :height="'260px'"
          :useCustomImageHandler="false"
          :htmlBtn="true"
          :placeholder="
            'Sınavın zorluğu, soru dağılımı, önceki TUS sorularıyla benzerlik, kitaplarımızdan referanslar vb. hakkında genel bir değerlendirme yazın.'
          "
        />
      </div>

      <template #otherbuttons>
        <r-btn
          bgcolor="#15880d"
          size="medium"
          @click="saveComment"
          :disabled="!canSave || isSaving"
        >
          Kaydet
        </r-btn>
      </template>
    </r-modal>
  </div>
</template>

<script>
import { onBeforeMount, ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { mxDate, trToUpper } from "@/mix/global";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

export default {
  setup() {
    const store = useStore();
    const loaded = ref(false);
    const isLoading = ref(false);
    const isSaving = ref(false);

    const listData = ref({ data: [] });
    const q = ref("");

    const yearMonthList = ref([]);
    const selectedYearMonth = ref(null);

    const workMonth = ref("");
    const workYear = ref("");

    const teacherList = ref({ data: [] });
    const branchList = ref({ data: [] });

    const selectedBranchId = ref(null);

    const isExporting = ref(false);
    const modalVisible = ref(false);
    const formData = ref({
      id: 0,
      examId: null,
      examMonth: 0,
      examYear: 0,
      teacherId: null,
      branchId: null,
      commentHtml: ""
    });

    const listArray = computed(() => {
      const src = listData.value || {};
      return Array.isArray(src.data) ? src.data : [];
    });

    const searchfilter = v => {
      return (
        trToUpper(getTeacherName(v.teacherId)).includes(trToUpper(q.value)) ||
        trToUpper(getBranchName(v.branchId)).includes(trToUpper(q.value)) ||
        trToUpper(v.commentHtml || "").includes(trToUpper(q.value))
      );
    };

    const filteredListForExport = computed(() => {
      const base = listArray.value || [];
      const qVal = trToUpper((q.value || "").trim());
      const filtered = qVal ? base.filter(v => searchfilter(v)) : base.slice();

      const sorted = filtered.slice();
      sorted.sort((a, b) => {
        const branchA = (getBranchName(a.branchId) || "").toLocaleLowerCase("tr");
        const branchB = (getBranchName(b.branchId) || "").toLocaleLowerCase("tr");
        if (branchA !== branchB) {
          return branchA.localeCompare(branchB, "tr");
        }

        const teacherA = (getTeacherName(a.teacherId) || "").toLocaleLowerCase("tr");
        const teacherB = (getTeacherName(b.teacherId) || "").toLocaleLowerCase("tr");
        if (teacherA !== teacherB) {
          return teacherA.localeCompare(teacherB, "tr");
        }

        const yearDiff = (a.examYear || 0) - (b.examYear || 0);
        if (yearDiff !== 0) return yearDiff;

        const monthDiff = (a.examMonth || 0) - (b.examMonth || 0);
        if (monthDiff !== 0) return monthDiff;

        const idA = a.id || a.Id || 0;
        const idB = b.id || b.Id || 0;
        return idA - idB;
      });

      return sorted;
    });

    const headdata = computed(() => {
      return [
        {
          title: "Dönem",
          style: { width: "10%", justifyContent: "center" },
          key: "examYear",
          cval: v => `${v.examYear}-${v.examMonth.toString().padStart(2, "0")}`
        },
        {
          title: "Eğitmen",
          style: { width: "20%" },
          key: "teacherId"
        },
        {
          title: "Branş",
          style: { width: "20%" },
          key: "branchId"
        },
        {
          title: "Yorum (Kısa)",
          style: { width: "35%" },
          key: "commentHtml",
          html: true
        },
        {
          title: "Kayıt Tarihi",
          style: { width: "15%", justifyContent: "center" },
          key: "createDate",
          cval: v => mxDate("dd-mmm-yy-ddd-tt", v.createDate, " ")
        }
      ];
    });

    const opts = ref({
      title: "Sınav Yorumları",
      buttons: {
        style: { width: "15%" },
        edit: {
          show: false,
          func: () => {},
          showf: () => false
        },
        delete: {
          show: false,
          func: () => {},
          showf: () => false
        },
        add: {
          show: false,
          func: () => {}
        }
      }
    });

    const yearMonthOptions = computed(() => {
      const arr = Array.isArray(yearMonthList.value) ? yearMonthList.value : [];
      return arr.map(x => ({ txt: x, val: x }));
    });

    const teacherOptions = computed(() => {
      const arr =
        teacherList.value && Array.isArray(teacherList.value.data)
          ? teacherList.value.data
          : [];
      return [{ name: "Lütfen Seçiniz", id: null }, ...arr];
    });

    const tagSummary = ref([]);
    const tagSummaryQuestions = ref([]);
    const tagSummaryTotal = ref(0);
    const tagSummaryLoading = ref(false);
    const isTeacherUser = computed(() => {
      const catId = store.state.usercatid;
      return catId !== null && catId !== undefined && Number(catId) !== 0;
    });

    const currentTeacherId = computed(() => {
      const id = Number(store.state.userid);
      return Number.isFinite(id) && id > 0 ? id : null;
    });
    const tagColumnPriority = {
      "Vaka Mı?": 1,
      "Atipik Soru Mu?": 2,
      "Çalışılsa Yapılır.": 3,
      "Tus da Çıkmış Soru.": 4,
      "Farklı Branş Sorusu.": 5
    };

    const tagMatrixColumns = computed(() => {
      const labelSet = new Set();
      const rows = Array.isArray(tagSummaryQuestions.value)
        ? tagSummaryQuestions.value
        : [];

      rows.forEach(r => {
        const labels = r.tagLabels || r.TagLabels || [];
        if (!Array.isArray(labels)) return;
        labels.forEach(label => {
          const clean = String(label || "").trim();
          if (clean) labelSet.add(clean);
        });
      });

      return [...labelSet].sort((a, b) => {
        const pa = tagColumnPriority[a] || 999;
        const pb = tagColumnPriority[b] || 999;
        if (pa !== pb) return pa - pb;
        return a.localeCompare(b, "tr");
      });
    });

    const tagMatrixRows = computed(() => {
      const rows = Array.isArray(tagSummaryQuestions.value)
        ? [...tagSummaryQuestions.value]
        : [];

      rows.sort(
        (a, b) =>
          Number(a.examNumber ?? a.ExamNumber ?? a.number ?? a.Number ?? 0) -
          Number(b.examNumber ?? b.ExamNumber ?? b.number ?? b.Number ?? 0)
      );

      return rows.map((r, idx) => {
        const labels = r.tagLabels || r.TagLabels || [];
        const tags = {};
        if (Array.isArray(labels)) {
          labels.forEach(label => {
            const clean = String(label || "").trim();
            if (clean) tags[clean] = true;
          });
        }

        return {
          id: r.id ?? r.Id ?? idx,
          // Soru Numarası: sınavın orijinal soru numarası (ExamNumber)
          number:
            r.examNumber ??
            r.ExamNumber ??
            r.number ??
            r.Number ??
            "-",
          branch:
            r.subCategoryName ??
            r.SubCategoryName ??
            r.categoryName ??
            r.CategoryName ??
            "-",
          difficulty:
            r.difficultyLevelDescription ?? r.DifficultyLevelDescription ?? "-",
          tags
        };
      });
    });


    const branchOptions = computed(() => {
      const arr =
        branchList.value && Array.isArray(branchList.value.data)
          ? branchList.value.data
          : [];
      return [{ title: "Lütfen Seçiniz", id: null }, ...arr];
    });
    const modalBranchOptions = computed(() => {
      if (!isTeacherUser.value) return branchOptions.value;
      const teacherBranchId = Number(store.state.usercatid);
      const all = Array.isArray(branchList.value?.data) ? branchList.value.data : [];
      const ownBranch = all.find(x => Number(x?.id) === teacherBranchId);
      return ownBranch ? [ownBranch] : [];
    });

    const periodLabel = computed(() => {
      if (!formData.value.examYear || !formData.value.examMonth) return "";
      return `${
        formData.value.examYear
      }-${formData.value.examMonth.toString().padStart(2, "0")}`;
    });

    const modalTitle = computed(() => {
      return formData.value.id ? "Sınav Yorumu Düzenle" : "Yeni Sınav Yorumu";
    });

    const canSave = computed(() => {
      return (
        formData.value.examYear &&
        formData.value.examMonth &&
        formData.value.teacherId &&
        formData.value.branchId &&
        (formData.value.commentHtml || "").trim() !== ""
      );
    });

    const getTeacherName = teacherId => {
      const arr =
        teacherList.value && Array.isArray(teacherList.value.data)
          ? teacherList.value.data
          : [];
      const t = arr.find(x => x.id === teacherId);
      return t ? t.name : "";
    };

    const getBranchName = branchId => {
      const arr =
        branchList.value && Array.isArray(branchList.value.data)
          ? branchList.value.data
          : [];
      const b = arr.find(x => x.id === branchId);
      return b ? b.title : "";
    };

    const shortComment = html => {
      if (!html) return "";
      const tmp = document.createElement("div");
      tmp.innerHTML = html;
      const text = (tmp.innerText || "").trim();
      if (text.length <= 200) return text;
      return text.substring(0, 200) + "...";
    };

    const stripHtml = html => {
      if (!html) return "";
      let s = html;
      // Satır sonlarını ve liste yapısını korumaya çalış
      s = s.replace(/<br\s*\/?>/gi, "\n");
      s = s.replace(/<\/p>/gi, "\n\n");
      s = s.replace(/<li[^>]*>/gi, "• ");
      s = s.replace(/<\/li>/gi, "\n");
      const tmp = document.createElement("div");
      tmp.innerHTML = s;
      let text = (tmp.textContent || tmp.innerText || "").trim();
      // Çoklu boş satırları sadeleştir
      text = text.replace(/\n{3,}/g, "\n\n");
      return text;
    };

    const escapeHtml = text => {
      if (text == null) return "";
      return String(text)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    };

    const canExportKapak = computed(() => {
      return (
        selectedYearMonth.value &&
        filteredListForExport.value.length > 0 &&
        !isExporting.value
      );
    });

    const buildTagMatrixForBranch = async branchId => {
      if (!branchId || !workYear.value || !workMonth.value) {
        return { columns: [], rows: [], total: 0 };
      }

      try {
        const params = {
          categoryid: branchId,
          subcatid: 0,
          page: 1,
          size: 300,
          order: 0,
          workmonth: String(workMonth.value).padStart(2, "0"),
          workyear: String(workYear.value)
        };

        const res = await store.dispatch("getDatas", {
          api: "questions/GetQuestionsByCategory",
          params
        });
        const questions = Array.isArray(res?.data)
          ? res.data
          : Array.isArray(res?.Data)
          ? res.Data
          : [];

        const total = questions.length;
        const labelSet = new Set();

        questions.forEach(r => {
          const labels = r.tagLabels || r.TagLabels || [];
          if (!Array.isArray(labels)) return;
          labels.forEach(label => {
            const clean = String(label || "").trim();
            if (clean) labelSet.add(clean);
          });
        });

        const columns = [...labelSet].sort((a, b) => {
          const pa = tagColumnPriority[a] || 999;
          const pb = tagColumnPriority[b] || 999;
          if (pa !== pb) return pa - pb;
          return a.localeCompare(b, "tr");
        });

        const rows = questions
          .slice()
          .sort(
            (a, b) =>
              Number(a.examNumber ?? a.ExamNumber ?? a.number ?? a.Number ?? 0) -
              Number(b.examNumber ?? b.ExamNumber ?? b.number ?? b.Number ?? 0)
          )
          .map((r, idx) => {
            const labels = r.tagLabels || r.TagLabels || [];
            const tags = {};
            if (Array.isArray(labels)) {
              labels.forEach(label => {
                const clean = String(label || "").trim();
                if (clean) tags[clean] = true;
              });
            }

            return {
              id: r.id ?? r.Id ?? idx,
              number:
                r.examNumber ??
                r.ExamNumber ??
                r.number ??
                r.Number ??
                "-",
              branch:
                r.subCategoryName ??
                r.SubCategoryName ??
                r.categoryName ??
                r.CategoryName ??
                "-",
              difficulty:
                r.difficultyLevelDescription ??
                r.DifficultyLevelDescription ??
                "-",
              tags
            };
          });

        return { columns, rows, total };
      } catch (err) {
        return { columns: [], rows: [], total: 0 };
      }
    };

    const buildBranchSummaryHtml = (
      branchName,
      period,
      matrix,
      totalCount
    ) => {
      const { columns, rows } = matrix;

      const headerCells = [
        "Soru Numarası",
        "Bölümü",
        "Zorluk Seviyesi",
        ...columns
      ]
        .map(
          title =>
            `<th style="padding:4px 6px;border:1px solid #dde4f5;font-size:11px;color:#0038a0;text-align:left;background-color:#edf1fb;">${escapeHtml(
              title
            )}</th>`
        )
        .join("");

      const bodyRows = rows
        .map((row, idx) => {
          const bg = idx % 2 === 0 ? "#ffffff" : "#f7f9ff";
          const tagCells = columns
            .map(label => {
              const mark = row.tags[label] ? "✓" : "";
              return `<td style="padding:4px 6px;border:1px solid #dde4f5;font-size:11px;text-align:center;background:${bg};">${mark}</td>`;
            })
            .join("");

          return `<tr>
  <td style="padding:4px 6px;border:1px solid #dde4f5;font-size:11px;background:${bg};">${escapeHtml(
    row.number
  )}</td>
  <td style="padding:4px 6px;border:1px solid #dde4f5;font-size:11px;background:${bg};">${escapeHtml(
    row.branch
  )}</td>
  <td style="padding:4px 6px;border:1px solid #dde4f5;font-size:11px;background:${bg};">${escapeHtml(
    row.difficulty
  )}</td>
  ${tagCells}
</tr>`;
        })
        .join("");

      return `
<div style="font-family:Arial,Helvetica,'Segoe UI',sans-serif;font-size:12px;color:#111;display:flex;flex-direction:column;gap:8px;">
  <h3 style="margin:0 0 4px 0;font-size:14px;font-weight:600;color:#0038a0;">
    Seçilen branş için dinamik etiket özeti
    <span style="font-weight:400;font-size:12px;color:#555;margin-left:4px;">(${escapeHtml(
      period
    )})</span>
  </h3>
  <div style="font-size:11px;color:#333;margin-bottom:4px;">
    Branş: <strong>${escapeHtml(branchName)}</strong>
    &nbsp;|&nbsp; Toplam soru: <strong>${totalCount}</strong>
  </div>
  <table style="border-collapse:collapse;width:100%;font-family:inherit;">
    <thead>
      <tr>
        ${headerCells}
      </tr>
    </thead>
    <tbody>
      ${bodyRows}
    </tbody>
  </table>
  <div style="margin-top:4px;font-size:10px;color:#555;">
    Toplam soru: <strong>${totalCount}</strong>
  </div>
</div>`;
    };

    const createKapakPdf = async () => {
      if (isExporting.value) return;
      const list = filteredListForExport.value;
      if (!list.length) return;
      isExporting.value = true;
      try {
        const doc = new jsPDF("p", "mm", "a4");
        const pageW = 210;
        const pageH = 297;
        const padding = 20;

        const renderTextPage = async text => {
          const el = document.createElement("div");
          el.style.cssText = [
            "position:fixed;left:-9999px;top:0;",
            "width:" + pageW + "mm;height:" + pageH + "mm;",
            "padding:" + padding + "mm;box-sizing:border-box;",
            "background:#fff;color:#000;",
            "font-family:Arial,Helvetica,'Segoe UI',sans-serif;font-size:11pt;line-height:1.5;",
            "white-space:pre-wrap;word-wrap:break-word;overflow:hidden;",
            "display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;text-align:left;"
          ].join("");
          el.textContent = text;
          document.body.appendChild(el);
          const canvas = await html2canvas(el, {
            scale: 2,
            backgroundColor: "#ffffff",
            useCORS: true,
            logging: false
          });
          document.body.removeChild(el);
          const imgData = canvas.toDataURL("image/png");
          doc.addImage(imgData, "PNG", 0, 0, pageW, pageH);
        };

        const renderHtmlPage = async html => {
          const el = document.createElement("div");
          el.style.cssText = [
            "position:fixed;left:-9999px;top:0;",
            "width:" + pageW + "mm;height:" + pageH + "mm;",
            "padding:" + padding + "mm;box-sizing:border-box;",
            "background:#fff;color:#000;",
            "font-family:Arial,Helvetica,'Segoe UI',sans-serif;font-size:11pt;line-height:1.4;",
            "overflow:hidden;"
          ].join("");
          el.innerHTML = html;
          document.body.appendChild(el);
          const canvas = await html2canvas(el, {
            scale: 2,
            backgroundColor: "#ffffff",
            useCORS: true,
            logging: false
          });
          document.body.removeChild(el);
          const imgData = canvas.toDataURL("image/png");
          doc.addImage(imgData, "PNG", 0, 0, pageW, pageH);
        };

        const periodLabel =
          selectedYearMonth.value ||
          `${workYear.value}-${String(workMonth.value).padStart(2, "0")}`;
        const coverText = [
          "Hocalarımızın Sınav Değerlendirmeleri",
          "",
          "Referans listesi kapak metni",
          "Dönem: " + periodLabel,
          "",
          "Sınav ile ilgili eğitmen değerlendirmeleri aşağıdadır."
        ].join("\n");
        await renderTextPage(coverText);

        const branchIds = [
          ...new Set(list.map(r => r.branchId).filter(b => b != null))
        ];

        for (const branchId of branchIds) {
          const branchName = getBranchName(branchId) || "Branş Belirtilmedi";
          const branchComments = list.filter(r => r.branchId === branchId);

          const matrix = await buildTagMatrixForBranch(branchId);

          doc.addPage();
          const summaryHtml = buildBranchSummaryHtml(
            branchName,
            periodLabel,
            matrix,
            matrix.total
          );
          await renderHtmlPage(summaryHtml);

          for (let i = 0; i < branchComments.length; i++) {
            const row = branchComments[i];
            const teacherName = getTeacherName(row.teacherId);
            const bName = getBranchName(row.branchId);
            const period = `${row.examYear}-${String(row.examMonth).padStart(
              2,
              "0"
            )}`;
            const body = stripHtml(row.commentHtml || "");
            const pageText = [
              "Dönem: " + period,
              "Eğitmen: " + teacherName,
              "Branş: " + bName,
              "",
              body || "(Yorum yok)"
            ].join("\n");
            doc.addPage();
            await renderTextPage(pageText.trim());
          }
        }

        const safeName =
          "sinav_yorumlari_kapak_" +
          (periodLabel || "donem").replace(/\s+/g, "_") +
          ".pdf";
        doc.save(safeName);
      } finally {
        isExporting.value = false;
      }
    };

    const onYearMonthChange = e => {
      if (!e || !e.val) return;
      selectedYearMonth.value = e.val;
      const parts = e.val.split("-");
      if (parts.length === 2) {
        const [year, month] = parts;
        workYear.value = parseInt(year);
        workMonth.value = parseInt(month);
      }
    };

    const loadYearMonths = async () => {
      const res = await store.dispatch("getDatas", {
        api: "settings/getmonthyear"
      });
      const arr = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res?.Data)
        ? res.Data
        : [];
      yearMonthList.value = Array.isArray(arr) ? arr : [];
    };

    const loadTeachers = async () => {
      const res = await store.dispatch("getDatas", {
        api: "notes/getteacherlist"
      });
      teacherList.value = res?.data ? { data: res.data } : { data: [] };
    };

    const loadBranches = async () => {
      const res = await store.dispatch("getDatas", {
        api: "categories/getsubcategories",
        params: { pid: 0 }
      });
      const arr = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res?.Data)
        ? res.Data
        : [];
      branchList.value = { data: Array.isArray(arr) ? arr : [] };
    };

    const loadTagSummaryForCurrentBranch = async () => {
      const branchId = formData.value.branchId;
      if (!branchId || !workYear.value || !workMonth.value) {
        tagSummary.value = [];
        tagSummaryQuestions.value = [];
        tagSummaryTotal.value = 0;
        return;
      }

      tagSummaryLoading.value = true;
      try {
        const params = {
          categoryid: branchId,
          subcatid: 0,
          page: 1,
          size: 300,
          order: 0,
          workmonth: String(workMonth.value).padStart(2, "0"),
          workyear: String(workYear.value)
        };

        const res = await store.dispatch("getDatas", {
          api: "questions/GetQuestionsByCategory",
          params
        });
        const rows = Array.isArray(res?.data)
          ? res.data
          : Array.isArray(res?.Data)
          ? res.Data
          : [];
        tagSummaryQuestions.value = rows;

        const total = rows.length;
        const map = {};

        rows.forEach(r => {
          const labels = r.tagLabels || r.TagLabels || [];
          if (Array.isArray(labels)) {
            labels.forEach(label => {
              if (!label) return;
              const key = String(label);
              map[key] = (map[key] || 0) + 1;
            });
          }
        });

        const summary = Object.entries(map).map(([name, count]) => {
          const percent = total > 0 ? (count * 100) / total : 0;
          return {
            name,
            count,
            percent,
            percentText: total > 0 ? percent.toFixed(1) + "%" : "-"
          };
        });

        summary.sort((a, b) => b.count - a.count);

        tagSummary.value = summary;
        tagSummaryTotal.value = total;
      } catch (err) {
        tagSummary.value = [];
        tagSummaryQuestions.value = [];
        tagSummaryTotal.value = 0;
      } finally {
        tagSummaryLoading.value = false;
      }
    };

    const getComments = async () => {
      if (!workYear.value || !workMonth.value) return { data: [] };

      const params = {
        examYear: workYear.value,
        examMonth: workMonth.value
      };

      if (selectedBranchId.value) {
        params.branchId = selectedBranchId.value;
      }

      const res = await store.dispatch("getDatas", {
        api: "examteachercomments/getcommentsbyperiod",
        params
      });
      return res || { data: [] };
    };

    const reloadList = async () => {
      isLoading.value = true;
      try {
        const res = await getComments();
        listData.value = res || { data: [] };
      } finally {
        isLoading.value = false;
      }
    };

    const openNewModal = () => {
      if (!workYear.value || !workMonth.value) return;

      formData.value = {
        id: 0,
        examId: null,
        examMonth: workMonth.value,
        examYear: workYear.value,
        teacherId: isTeacherUser.value ? currentTeacherId.value : null,
        branchId: isTeacherUser.value
          ? Number(store.state.usercatid) || null
          : selectedBranchId.value || null,
        commentHtml: ""
      };
      modalVisible.value = true;
      loadTagSummaryForCurrentBranch();
    };

    const openEditModal = datarow => {
      formData.value = {
        id: datarow.id,
        examId: datarow.examId || null,
        examMonth: datarow.examMonth,
        examYear: datarow.examYear,
        teacherId: isTeacherUser.value
          ? currentTeacherId.value
          : datarow.teacherId,
        branchId: isTeacherUser.value
          ? Number(store.state.usercatid) || null
          : datarow.branchId,
        commentHtml: datarow.commentHtml || ""
      };
      modalVisible.value = true;
      loadTagSummaryForCurrentBranch();
    };

    const saveComment = async () => {
      if (!canSave.value || isSaving.value) return;
      isSaving.value = true;
      try {
        const payload = { ...formData.value };
        await store.dispatch("postDatas", {
          api: "examteachercomments/savecomment",
          data: payload
        });
        modalVisible.value = false;
        await reloadList();
      } finally {
        isSaving.value = false;
      }
    };

    const deleteComment = async datarow => {
      if (isSaving.value) return;
      if (!datarow || !datarow.id) return;
      isSaving.value = true;
      try {
        await store.dispatch("postDatas", {
          api: "examteachercomments/deletecomment",
          data: { id: parseInt(datarow.id) }
        });
        await reloadList();
      } finally {
        isSaving.value = false;
      }
    };

    onBeforeMount(async () => {
      // Yıl-Ay kombinasyonlarını yükle (en güncel dönem varsayılan)
      await loadYearMonths();
      if (yearMonthList.value.length > 0) {
        const chosen = yearMonthList.value[0];
        selectedYearMonth.value = chosen;
        const parts = String(chosen).split("-");
        if (parts.length === 2) {
          const [year, month] = parts;
          workYear.value = parseInt(year);
          workMonth.value = parseInt(month);
        }
      }

      await loadTeachers();
      await loadBranches();
      await reloadList();
      loaded.value = true;
    });

    watch(
      () => formData.value.branchId,
      () => {
        if (modalVisible.value) {
          loadTagSummaryForCurrentBranch();
        }
      }
    );

    watch(
      () => modalVisible.value,
      isOpen => {
        if (
          isOpen &&
          formData.value
        ) {
          if (isTeacherUser.value && currentTeacherId.value) {
            formData.value.teacherId = currentTeacherId.value;
          }
          if (isTeacherUser.value) {
            formData.value.branchId = Number(store.state.usercatid) || null;
          }
        }
      }
    );

    return {
      loaded,
      isLoading,
      listData,
      listArray,
      headdata,
      opts,
      q,
      searchfilter,
      yearMonthList,
      yearMonthOptions,
      selectedYearMonth,
      selectedBranchId,
      branchOptions,
      modalBranchOptions,
      onYearMonthChange,
      reloadList,
      getTeacherName,
      getBranchName,
      shortComment,
      modalVisible,
      formData,
      modalTitle,
      periodLabel,
      teacherOptions,
      isTeacherUser,
      saveComment,
      openNewModal,
      openEditModal,
      deleteComment,
      canSave,
      isSaving,
      canExportKapak,
      createKapakPdf,
      isExporting,
      tagSummary,
      tagMatrixColumns,
      tagMatrixRows,
      tagSummaryTotal,
      tagSummaryLoading
    };
  }
};
</script>

<style scoped>
.hint-box {
  padding: 12px 14px;
  background-color: #f4f6fb;
  border-radius: 6px;
  border: 1px solid #dde4f5;
}

.hint-box h4 {
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #0038a0;
}

.hint-box ul {
  padding-left: 18px;
}

.hint-box li {
  margin-bottom: 4px;
  font-size: 13px;
}

.tag-summary-box {
  padding: 10px 12px;
  background-color: #f9fafc;
  border-radius: 6px;
  border: 1px solid #dde4f5;
}

.tag-summary-box h4 {
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 600;
  color: #0038a0;
}

.tag-summary-period {
  font-weight: 400;
  font-size: 12px;
  color: #555;
  margin-left: 4px;
}

.tag-summary-loading,
.tag-summary-empty {
  font-size: 13px;
  color: #555;
}

.tag-summary-table-wrapper {
  margin-top: 4px;
  overflow: visible;
}

.tag-summary-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.tag-summary-table th,
.tag-summary-table td {
  border: 1px solid #dde4f5;
  padding: 4px 6px;
  color: #222;
}

.tag-summary-table th {
  background-color: #edf1fb;
  color: #0038a0;
  font-weight: 600;
  text-align: left;
}

.tag-cell-check {
  text-align: center;
  font-weight: 600;
}

.tag-summary-footer {
  margin-top: 4px;
  font-size: 12px;
  color: #333;
}

:deep(.exam-comment-modal .r-modal-C) {
  max-height: 92vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

:deep(.exam-comment-modal .r-modal-content-C) {
  flex: 1 1 auto;
  min-height: 0;
  max-height: calc(92vh - 150px);
  overflow-y: auto !important;
  padding-bottom: 12px;
}

:deep(.exam-comment-modal .r-modal-buttons-C) {
  position: sticky;
  bottom: 0;
  z-index: 8;
  background: #fff;
  border-top: 1px solid #e7e7e7;
}
</style>
